import React from 'react';
import {ReviewUnit} from "@onegovbugs/onegov-react-components";
import styles from "./ReviewUnitApplication.module.scss";
import {format2FAAddress} from "../../../utils/FormatHelper";

export const ApplicantDetailReviewUnit = ({props, personalDetails, twoFAData, onEditUrl, title, type}) => {   
  
  const getAddress = () => {
    const address = personalDetails.address;
    if (address && address.addressNotChanged === false){
      if (address && address.enterManually && !address.international) {
        return `${address.addressLine}, ${address.suburb}, ${address.state.label}, ${address.postcode}`;
      } else if (address && address.lookupValue && address.lookupValue.label) {
        return address.lookupValue.label;
      } else {
        return  `${address.addressLine}, ${address.suburb}, ${address.state?address.state+',':''} ${address.postcode}, ${address.country}`;
      }
    }
    else{
      return format2FAAddress(twoFAData.addressses, "Postal");
    }
  };
  // const addressPostalFinal = (
  //     (personalDetails && personalDetails.address) 
  //       ? (personalDetails.address.enterManually === true || personalDetails.address.international === true) 
  //           ? (
  //               (personalDetails.address.addressLine + ", ")+
  //               (personalDetails.address.suburb +", ")+
  //               ((personalDetails.address.international === true ? personalDetails.address.state : personalDetails.address.state.value) + ", ")+
  //               (personalDetails.address.postcode)+
  //               (personalDetails.address.international === true ? ", " + personalDetails.address.country : "")
  //             )
  //           :(
  //               personalDetails.address.details.Address.PartialAddress+", "+personalDetails.address.details.Address.Country
  //             )
  //     :'');

    return (
        <ReviewUnit
        title={title}
        onEdit={() => props.history.push({
            pathname: onEditUrl,
          })}        
        //onEdit={() => props.history.push("/import-export/applicant-details")}
      >

        {
          type === "Organisation" && 
          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>{personalDetails.organisationIdType} </em>
              </div>
              <div>{personalDetails.organisationIdType === 'ABN' ? personalDetails.abn : personalDetails.acn}</div>
            </div>
            <div className={"col-12 col-md-6"}>
              <div>
                <em>Business Name</em>
              </div>
              <div>{personalDetails.organisationBusinessName}</div>
            </div>  
          </div>          
        }

        <div className={`row ${styles.infoLine}`}>
          <div className={"col-12 col-md-6"}>
            <div>
              <em>Full Name</em>
            </div>
            <div className={styles.camelCase}>
              {
                type === "Organisation"
                  ? personalDetails.firstname + " " + personalDetails.middlename  + " " + personalDetails.lastname
                  : (twoFAData?twoFAData.firstName:"") + (twoFAData?twoFAData.middleName === undefined ? "" : ` ${twoFAData.middleName}`:"") + " " + (twoFAData?twoFAData.lastName:"")
              }
            </div>
          </div>
          <div className={"col-12 col-md-6"}>
            <div>
              <em>Email</em>
            </div>
            <div>{personalDetails?.emailAddress}</div>
          </div>  
        </div>

        {
          type === 'Individual' &&
          <React.Fragment>
            <div className={`row ${styles.infoLine}`}>
            
              <div className={"col-12 col-md-6"}>
                  <div>
                    <em>Date of Birth</em>
                  </div>
                  <div>{(twoFAData?twoFAData.day +"/"+twoFAData.month+"/"+twoFAData.year:"")}</div>
              </div>      

              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Mobile Number</em>
                </div>
                <div>{personalDetails?.mobileNumber}</div>
              </div>

            </div>

            <div className={`row ${styles.infoLine}`}>

              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Daytime Telephone Number</em>
                </div>
                <div>{personalDetails?.dayTimeTelephoneNumber}</div>
              </div>

              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Postal Address</em>
                </div>
                <div>{getAddress()}</div>
              </div>

            </div>
          </React.Fragment>
        }

        {
          type === 'Organisation' &&
          <React.Fragment>
            <div className={`row ${styles.infoLine}`}>
            
              <div className={"col-12 col-md-6"}>
                  <div>
                    <em>Daytime Telephone Number</em>
                  </div>
                  <div>{personalDetails?.dayTimeTelephoneNumber}</div>
              </div> 

              <div className={"col-12 col-md-6"}>
                <div>
                  <em>Postal Address</em>
                </div>
                <div>{getAddress()}</div>
              </div>                    

            </div>
          </React.Fragment>
        }        
          

          
      </ReviewUnit>
              
    )
}